var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.9 24.9",
    style: {
      enableBackground: "new 0 0 24.9 24.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#808080;stroke-width:2;stroke-linecap:round;}\r\n\t.st1{display:none;fill:#FFFFFF;}\r\n\t.st2{fill:#808080;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_252",
    transform: "translate(-436.414 -35.829)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_91",
    className: "st0",
    x1: 437.8,
    y1: 59.3,
    x2: 443.1,
    y2: 54.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_523",
    transform: "translate(461.312 35.829) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.7,20.9c-5.6,0-10.2-4.6-10.2-10.2S5.1,0.5,10.7,0.5s10.2,4.6,10.2,10.2S16.3,20.9,10.7,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.7,1C5.3,1,1,5.3,1,10.7s4.3,9.7,9.7,9.7s9.7-4.3,9.7-9.7S16,1,10.7,1 M10.7,0c5.9,0,10.7,4.8,10.7,10.7 s-4.8,10.7-10.7,10.7S0,16.6,0,10.7S4.8,0,10.7,0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.39c9aab12776522b4ae0c94c38e8d650.svg";
export { ForwardRef as ReactComponent };